// extracted by mini-css-extract-plugin
export var cartContainer = "_ox-4";
export var gray = "_ox-1";
export var itemContainer = "_ox-2";
export var itemDetails = "_ox-3";
export var strong = "_ox-0";